import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import styles from "./countrySelect.style";
import Flag from "react-world-flags";
import T from "Translate";
import Popover from "@material-ui/core/Popover";
import Hidden from "@material-ui/core/Hidden";
import RegionMarkets from "./RegionMarkets";
import ToggleDisplay from "Common/ToggleDisplay";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

const disableCountries = ["bahamas", "dominican republic"];
const checkDisableCountries = country => !disableCountries.includes(country);

const CountrySelect = props => {
    const { classes, markets, selectedCountry } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [regionType, setRegionType] = useState("americas");
    const [regionMarkets, setRegionMarkets] = useState([]);
    const [regionShow, setRegionShow] = useState([]);

    const marketRegions = [...new Set(markets.filter(market => market.region).map(market => market.region))];

    useEffect(() => {
        //console.log(markets)
        setRegionMarkets(markets.filter(market => market.region === regionType && checkDisableCountries(market.country)));
    }, [regionType]);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const countryChange = countryCode => {
        props.onCountryChange(countryCode);
        handleClose();
    };
    const langCountryChange = (countryCode, languageCode) => {
        //props.onCountryChange(countryCode)
        //props.onLanguageChange(languageCode)
        props.onCountryAndLanguageChange(countryCode, languageCode);
        handleClose();
    };

    const openRegion = region => {
        setRegionType(region);
        setRegionShow(prevRegionShow => {
            if (prevRegionShow.includes(region)) {
                return markets.filter(market => market.region !== region);
            } else {
                return [...prevRegionShow, region];
            }
        });
    };

    return (
        <form className={classes.root} autoComplete="off">
            <FormControl data-testid="country_picker">
                <Flag code={selectedCountry} height="16" onClick={handleClick} style={{ cursor: "pointer" }} />
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    //anchorReference="anchorPosition"
                    //anchorPosition={{ top: 50, left: 40 }}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    PaperProps={{
                        style: { width: "100%" }
                    }}
                    data-testid="country_popover"
                >
                    <Hidden mdUp>
                        <div className={classes.regions}>
                            <div className={classes.selectRegion}>
                                <span data-testid="select_region_title">
                                    <T>select_region</T>
                                </span>
                                <span
                                    onClick={handleClose}
                                    className={classes.closeButton}
                                    data-testid="country_popover_close_button"
                                >
                                    X
                                </span>
                            </div>
                            <div className={classes.regionTypes}>
                                <div style={{ width: "100%" }}>
                                    {marketRegions.map(region => (
                                        <div key={region}>
                                            <a
                                                key={region}
                                                onClick={() => openRegion(region)}
                                                className={classes.regionList}
                                                data-testid="region"
                                            >
                                                <T>{region}</T>
                                                {regionShow.includes(region) ? (
                                                    <KeyboardArrowUpIcon style={{ verticalAlign: "middle" }} />
                                                ) : (
                                                    <KeyboardArrowDownIcon style={{ verticalAlign: "middle" }} />
                                                )}
                                            </a>
                                            <hr />
                                            <ToggleDisplay if={regionShow.includes(region)}>
                                                <RegionMarkets
                                                    props={props}
                                                    regionMarkets={markets.filter(market => market.region === region)}
                                                    countryChange={countryChange}
                                                    langCountryChange={langCountryChange}
                                                />
                                                <hr />
                                            </ToggleDisplay>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Hidden>
                    <Hidden smDown>
                        <div className={classes.regions}>
                            <div className={classes.selectRegion}>
                                <span data-testid="select_region_title">
                                    <T>select_region</T>
                                </span>
                                <span
                                    onClick={handleClose}
                                    className={classes.closeButton}
                                    data-testid="country_popover_close_button"
                                >
                                    X
                                </span>
                            </div>
                            <div className={classes.regionTypes}>
                                {marketRegions.map(region => (
                                    <a
                                        key={region}
                                        onClick={() => setRegionType(region)}
                                        className={region === regionType ? classes.regionListUnderLine : classes.regionList}
                                        data-testid="region"
                                    >
                                        <T>{region}</T>
                                    </a>
                                ))}
                            </div>
                            <hr className={classes.divder} />
                            <RegionMarkets
                                props={props}
                                regionMarkets={regionMarkets}
                                countryChange={countryChange}
                                langCountryChange={langCountryChange}
                            />
                        </div>
                    </Hidden>
                </Popover>
                {/*<NativeSelect
          value = {selectedCountry}
          onChange = {e => props.onChange(e.target.value)}
          input={<BootstrapInput name="country" />}
        >
          {
            markets && markets.sort((a, b)=>{
                var nameA=a.country.toLowerCase(), nameB=b.country.toLowerCase()
                if (nameA < nameB) //sort string ascending
                    return -1
                if (nameA > nameB)
                    return 1
                return 0 //default return value (no sorting)
            }).map(market => {
              const { countryCode, country } = market;
              return(
                <option value={countryCode} key={countryCode}>
                  {ucFirst(country)}
                </option>
              )
            })
          }
        </NativeSelect>*/}
            </FormControl>
        </form>
    );
};

CountrySelect.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CountrySelect);



// WEBPACK FOOTER //
// ./src/components/StartContainer/CountrySelect/CountrySelect.js